<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: thread.forumSubcategory.gradeSubject.gradeID} }">
                                {{ thread.forumSubcategory.gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/category', params: {id: thread.forumSubcategory.gradeSubjectID} }">
                                {{ thread.forumSubcategory.gradeSubject.subject.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: thread.forumSubcategoryID} }">
                                {{ thread.forumSubcategory.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/view', params: {id: thread.id} }">
                                {{ thread.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            Edit
                        </li>
                    </ul>
                </nav>
                <div class="row mb-3">
                    <div class="col">
                        <form v-on:submit.prevent="save">
                            <div class="card shadow-sm mb-3 border-0">
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <div class="col-auto">
                                            <h3 class="font-weight-bold">Edit Thread</h3>
                                            <h4 class="font-weight-medium mb-0">
                                                {{ profile.name }}
                                                <small class="text-muted">{{ listRoles(profile) }}</small>
                                            </h4>
                                        </div>
                                        <div class="col">
                                            <h4 class="font-weight-medium mb-0 text-muted text-right">
                                                Judul Thread: <strong>{{ thread.title }}</strong>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <label class="font-weight-bold">Judul</label>
                                            <input v-model="form.title" class="form-control form-control-sm" placeholder="Judul..." />
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <label class="font-weight-bold">Balas</label>
                                            <tinymce id="editor" v-model="form.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto ml-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Post
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import tinymce from 'vue-tinymce-editor';
    import { tinyMCEOptions, employeeRoles, additionalRoles } from '@/params.js';
    import { mapState } from 'vuex';

    export default {
        name: "ForumThreadEdit",
        computed: mapState([
            'profile'
        ]),
        components: {
            tinymce
        },
        data() {
            return {
                form: {
                    title: '',
                    content: ''
                },
                thread: {forumSubcategory: {gradeSubject: {grade: {}, subject: {}}}},
                roles: [],
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/thread/update/' + this.thread.id, this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'forum/thread/view', params: {id: this.thread.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles(user) {
                var roles = [];
                for (var i in additionalRoles) {
                    if (user['is' + additionalRoles[i].id]) {
                        roles.push(additionalRoles[i].id);
                    }
                }
                if (user.isEmployee) {
                    for (var i in employeeRoles) {
                        if (user.employee['is' + employeeRoles[i].id]) {
                            roles.push(employeeRoles[i].id);
                        }
                    }
                }
                return this.listRelations(this.roles.filter(object => roles.includes(object.id)));
            },
            roleElligible() {
                return this.profile.isAdmin || (this.thread.userID === this.profile.id && this.$moment().utcOffset(0).isBefore(this.$moment(this.thread.createdAt, 'YYYY-MM-DD HH:mm:ss').utcOffset(0).add(process.env.FORUM_CHANGE_MINUTES, 'minutes')));
            }
        },
        created() {
            this.roles = employeeRoles.concat(additionalRoles);
            this.axios.get(process.env.API_URL + '/thread/' + this.$route.params.id).then(response => {
                this.thread = response.data.data;
                if (!this.roleElligible()) {
                    this.$router.replace({name: 'error', params: {code: 403, message: 'User Not Authorize'}});
                }

                this.form = this.thread;

                document.title = 'Forum - Edit Thread ' + this.thread.title + ' | ' + process.env.APP_NAME;
            });

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/thread/Edit.vue